import { AddonForm } from 'components/PostTrade/Addon/AddonForm';
import { ProductModificationForm } from 'components/PostTrade/ProductModification/ProductModificationForm';
import { TradeAllocationForm } from 'components/PostTrade/TradeAllocation/TradeAllocationForm';

import { GenericErrorBoundary } from '../../../common-form/builder/form/GenericErrorBoundary';
import { EmptyWorkspace } from './EmptyWorkspace';

interface PostTradeTabContentProps {
  activeTabId: string | undefined;
  tabType: string | undefined;
}

export function PostTradeTabContent({ activeTabId, tabType }: PostTradeTabContentProps) {
  return activeTabId === undefined ? (
    <EmptyWorkspace />
  ) : (
    <GenericErrorBoundary key={activeTabId} context={{ tabId: activeTabId }}>
      {tabType === 'addOn' && <AddonForm tabId={activeTabId} />}
      {tabType === 'tradeAllocation' && <TradeAllocationForm tabId={activeTabId} />}
      {tabType === 'productModification' && <ProductModificationForm tabId={activeTabId} />}
    </GenericErrorBoundary>
  );
}
